export interface MatchTimeDefaults {
  first_half_mins: number;
  break_mins: number;
  second_half_mins: number;
}

const FALLBACK: MatchTimeDefaults = { first_half_mins: 20, break_mins: 5, second_half_mins: 20 };

export function defaultHalfMins(ageGroup: string | null | undefined): number {
  if (!ageGroup) return 20;
  const match = ageGroup.match(/U(\d+)/i);
  if (!match) return 20;
  const age = parseInt(match[1], 10);
  if (age <= 8) return 15;
  if (age <= 12) return 20;
  if (age <= 15) return 25;
  if (age === 16) return 30;
  if (age <= 19) return 35;
  return 40;
}

export function defaultMatchTimes(
  ageGroupName: string | null | undefined,
  dbDefaults?: MatchTimeDefaults | null,
): MatchTimeDefaults {
  if (dbDefaults && dbDefaults.first_half_mins > 0) return dbDefaults;
  const half = defaultHalfMins(ageGroupName);
  return { first_half_mins: half, break_mins: 5, second_half_mins: half };
}
